var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.334h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M99.905 85.329h341.333v341.334"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#f0f0f0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.561 100.645l14.843-10.807 14.867 10.794-4.979-15.302H41.525z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.332 103.632L82.649 86.16l-5.672 17.472-18.365.012 14.867 10.796-5.661 17.461 14.843-10.806 14.866 10.795-5.684-17.474 14.854-10.795z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.59 134.89l-5.684-17.474-5.673 17.474-18.365.011 14.867 10.795-5.661 17.462 14.844-10.807 14.866 10.796-5.685-17.474 14.856-10.794z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.846 166.146l-5.683-17.473-5.673 17.473-18.364.011 14.866 10.796-5.661 17.461 14.843-10.806 14.866 10.795-5.683-17.474 14.855-10.794z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.103 197.403l-5.683-17.474-5.672 17.474-18.366.011 14.866 10.795-5.66 17.462 14.843-10.807 14.866 10.796-5.684-17.473 14.855-10.795z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M213.359 228.659l-5.683-17.472-5.672 17.472-18.365.012 14.866 10.795-5.66 17.462 14.842-10.806 14.866 10.794-5.683-17.473 14.855-10.795z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M244.616 259.916l-5.683-17.473-5.672 17.473-18.366.012 14.867 10.795-5.661 17.462 14.844-10.807 14.866 10.794-5.685-17.472 14.855-10.794z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M275.872 291.173L270.19 273.7l-5.673 17.473-18.365.011 14.867 10.796-5.661 17.461 14.843-10.806 14.866 10.795-5.683-17.474 14.853-10.794z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M307.13 322.43l-5.683-17.474-5.674 17.474-18.364.011 14.866 10.795-5.661 17.462 14.844-10.807 14.866 10.796-5.684-17.474 14.855-10.794z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M338.386 353.686l-5.683-17.472-5.672 17.472-18.365.012 14.866 10.795-5.661 17.462 14.843-10.807 14.866 10.795-5.683-17.472 14.855-10.796z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369.643 384.943l-5.683-17.473-5.672 17.473-18.366.012 14.866 10.794-5.66 17.463 14.843-10.807 14.866 10.795-5.684-17.473 14.855-10.795z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.216 398.727l-5.672 17.472-18.365.012 14.394 10.453h19.278l14.414-10.476-18.366.011z"
}))));

export default SvgBa;